import { render, staticRenderFns } from "./GuidedTours.vue?vue&type=template&id=5d881920&scoped=true&"
import script from "./GuidedTours.vue?vue&type=script&lang=js&"
export * from "./GuidedTours.vue?vue&type=script&lang=js&"
import style0 from "./GuidedTours.vue?vue&type=style&index=0&id=5d881920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d881920",
  null
  
)

export default component.exports